// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "75cfca2e875a4e14","191": "4079f89bed5ed16f","396": "7c0a774d38bd87be","460": "25e2c40aa2f3cd54","498": "e4373f6460f97d80","917": "3629360e130ecd12","985": "5e12f319f9648e00",}[chunkId] + ".chunk.js"
}